<template>
<div class="cat-333">
    <div class="ui-content leader-sub scrollgolduser mobile-hide-list ">
        <div class="u_rank">
            <span>{{rankText}} in {{selectedEntity}}</span>
            <div class="squre-blue">{{yourRank}}</div>
        </div>
        <div class="leaderboard-info">
            <div class="leaderboard-title">{{selectedEntity}} LeaderBoard</div>
            <div
                class="leaderboard-usage-info"
            >Click on Chapter Name below to see the Chapter Leaderboard</div>
        </div>
        <div class="ui-content dashboard">
            <v-card class="mx-auto normal-card autohg">
                <div class="gold-user-block ">
                    <div class="gold-user-left">
                        <v-data-table
                            :headers="headers"
                            fixed-header
                            :items="studentsList"
                            :items-per-page="studentCount"
                            hide-default-header
                            hide-default-footer
                            class="elevation-2 cust-table"
                        >
                            <template v-slot:header="{ props: { headers } }">
                                <TableHeader :headers="headers" />
                            </template>
                            <template v-slot:body="{ items }">
                                <tbody>
                                    <tr class="student-list" v-for="item in items" :key="item.index">
                                        <td class="text-center lead-80">
                                            <div
                                                :class="item.isCurrentUser ? 'squre-blue' : ''"
                                            >{{ item.rank }}</div>
                                        </td>
                                        <td class="text-left lead-250">{{ item.name }}</td>
                                        
                                        <td class="text-left lead-min-120">{{ item.center }}</td>
                                        <td class="text-left lead-min-120">{{ item.batch }}</td>
                                        <td class="text-center lead-150">
                                            <v-btn
                                                v-if="item.is_boost_up"
                                                color="default"
                                                class="yellow-border"
                                            >Boost Up User</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>
                    </div>
                    <div class="gold-user-right">
                        <div class="chapter-name-title">Chapter Names</div>
                        <div class="chapter-list-ul">
                            <div
                                class="chapter-li"
                                v-for="chapter in chapters"
                                :key="chapter.id"
                                @click="getLeaderBoardByChapter(chapter)"
                                :class="{'skyblue-color': chapter.name == selectedEntity, '' : chapter.name != selectedEntity}"
                            >{{chapter.name}}</div>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
    </div>
    <div class="desk-hide-list  leader-sub mobile-leaderboard-ui">
        <div class="u_rank">
            <span>{{rankText}} in {{selectedEntity}}</span>
            <div class="squre-blue">{{yourRank}}</div>
        </div>
        <div class="accordion-list">
            <div class="leaderboard-usage-info">Click on Chapter Name below to see the Chapter Leaderboard</div>
            <v-row justify="center">
                <v-expansion-panels accordion >
                    <v-expansion-panel
                     class="chapter-li"
                            v-for="chapter in chapters"
                            :key="chapter.id"
                            @click="getLeaderBoardByChapter(chapter)">
                        <v-expansion-panel-header  :class="{'skyblue-color': chapter.name == selectedEntity, '' : chapter.name != selectedEntity}" >
                            <div>
                                    <div class="chapter-name-title" >Chapter Names</div>
                                    <div class="chapter-list-ul">{{chapter.name}}</div>
                            </div>
                        </v-expansion-panel-header>
                         <v-expansion-panel-content>
                            <div class="leaderboard-title">{{selectedEntity}} LeaderBoard</div>
                                <div class="gold-user-left">
                                    <v-data-table
                                        :headers="headers"
                                        fixed-header
                                        :items="studentsList"
                                        :items-per-page="studentCount"
                                        hide-default-header
                                        hide-default-footer
                                        class="elevation-2 cust-table"
                                    >
                                    <template v-slot:header="{ props: { headers } }">
                                        <TableHeader :headers="headers" />
                                    </template>
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                            <tr class="student-list" v-for="item in items" :key="item.index">
                                                <td class="text-center lead-80">
                                                    <div
                                                        :class="item.isCurrentUser ? 'squre-blue' : ''"
                                                    >{{ item.rank }}</div>
                                                </td>
                                                <td class="text-left lead-250">{{ item.name }}</td>
                                                
                                                <td class="text-left lead-min-120">{{ item.center }}</td>
                                                <td class="text-left lead-min-120">{{ item.batch }}</td>
                                                <td class="text-center lead-150">
                                                    <v-btn
                                                        v-if="item.is_boost_up"
                                                        color="default"
                                                        class="yellow-border"
                                                    >Boost Up User</v-btn>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                            </div>
                        </v-expansion-panel-content>
       
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>

        </div>
       
        <!-- <div> content
            <div>01. Mathematics for Physics LeaderBoard</div>
            <div>Rank table - copy as it is</div>

        </div> -->
       
    </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "SubjectLeaderboard",
    props: ["selectedSubject", "tabClicked", "studentId"],
    data() {
        return {
            selectedChapter: {},
            isSubjectSelected: true,
            selectedEntity: "",
            yourRank: 0,
            studentCount: 10,
            chapters: [],
            studentsList: [],
            rankText: "Your Rank",
            headers: [
                {
                    text: "Rank",
                    hideSort: true,
                    value: "rank",
                    class: "text-center lead-80"
                },
                {
                    text: "Name",
                    hideSort: true,
                    value: "name",
                    class: "text-left lead-250"
                },
                
                {
                    hideSort: true,
                    text: "Center",
                    value: "center",
                    class: "text-left lead-min-120"
                },
                {
                    hideSort: true,
                    text: "Batch",
                    value: "batch",
                    class: "text-left lead-min-120"
                },
                {
                    hideSort: true,
                    text: "",
                    value: "",
                    type: "blank",
                    class: "text-center lead-150"
                },
            ]
        };
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    mounted() {
        this.initializeData();
    },

    methods: {
        ...mapActions({
            getLeaderBoardData: "healthStore/getLeaderBoardData",
            getSubjectBatchWise: "resultStore/getSubjectBatchWise"
        }),
        ...mapMutations("app", ["addBreadCrumbChilde"]),
        initializeData() {
            this.selectedEntity = this.selectedSubject.name;
            this.chapters = this.selectedSubject.chapters;
            this.isSubjectSelected = true;
            this.getLeaderBoard();
            this.addBreadCrumbChilde([
                {
                    text: this.selectedSubject.name,
                    disabled: false
                }
            ]);
        },
        getLeaderBoardByChapter(chapter) {
            if (this.selectedChapter && this.selectedChapter.id == chapter.id)
                return;
            let routeName = this.$route.name;                
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd && crd.hasOwnProperty('selectedTab')) { 
                let tb = crd.tabDetails && crd.tabDetails[crd.selectedTab]  ? crd.tabDetails[crd.selectedTab] : {};
                tb.studentId = this.studentId;
                tb.selectedChapter = chapter;
                this.setRouteDetails(crd);
            }
            this.selectedEntity = chapter.name;
            this.selectedChapter = chapter;
            this.isSubjectSelected = false;
            this.getLeaderBoard();
            this.addBreadCrumbChilde([
                {
                    text: this.selectedSubject.name,
                    disabled: false
                },
                {
                    text: chapter.name,
                    disabled: false
                }
            ]);
        },
        getLeaderBoard() {
            this.rankText = this.user.role_id == this.roleIds.PA ? "Student Rank" : "Your Rank";
            let postData = {};
            if (this.isSubjectSelected) {
                postData.subject_id = this.selectedSubject.id;
            } else {
                postData.chapter_id = this.selectedChapter.id;
            }
            this.$root.showLoader = true;
            this.getLeaderBoardData(postData)
                .then(response => {
                    this.studentsList = [];
                    this.yourRank = 0;
                    if (response.list.length > 0) {
                        this.processLeaderBoardData(response);
                    }
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        processLeaderBoardData(response) {
            let students = [];
            this.studentCount = response.list.length;
            response.list.forEach(student => {
                let studentObj = {};
                let studentType = student.type.toUpperCase();
                studentObj.id = student.user_id;
                studentObj.rank = student.user_rank;
                studentObj.name = student.user_name;
                studentObj.batch = student.batch_name;
                studentObj.center = student.center_name;
                studentObj.isGold =
                    studentType == "GOLD" || studentType == "PLATINUM"
                        ? true
                        : false;
                studentObj.isCurrentUser = false;
                studentObj.is_boost_up = student.is_boost_up;
                if (student.user_id == this.studentId) {
                    studentObj.isCurrentUser = true;
                    this.yourRank = student.user_rank;
                }
                students.push(studentObj);
            });
            this.studentsList = students;
            this.defaultData();
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName); 
            if(crd && crd.hasOwnProperty('selectedTab')) {
                let tb = crd.tabDetails && crd.tabDetails[crd.selectedTab]  ? crd.tabDetails[crd.selectedTab] : null;
                if(tb != null && crd.selectedStudent.id == tb.studentId && tb.selectedChapter) {
                    this.getLeaderBoardByChapter(tb.selectedChapter)
                }
            }
        },
    },
    watch: {
        "selectedSubject.id": function(oldVal, newVal) {
            this.isSubjectSelected = true;
            this.getLeaderBoard();
        },
        tabClicked(val) {
            if (!this.isSubjectSelected) {
                let routeName = this.$route.name;                
                let crd = this.getCurrentRouteDetails(routeName); 
                if(crd && crd.hasOwnProperty('selectedTab')) { 
                    let tb = crd.tabDetails && crd.tabDetails[crd.selectedTab]  ? crd.tabDetails[crd.selectedTab] : {};
                    tb.studentId = this.studentId;
                    tb.selectedChapter = null;
                    this.setRouteDetails(crd);
                }

                this.isSubjectSelected = true;
                this.selectedEntity = this.selectedSubject.name;
                this.selectedChapter = {};
                this.getLeaderBoard();
            }
        }
    }
};
</script>